import React, { useState, useEffect } from "react";
import { FaDownload } from "react-icons/fa";
import Cookies from "js-cookie";

const Profilehead = ({ data , profileData}) => {
  const [languageData, setLanguageData] = useState(null);
  const [pseudo, setPseudo] = useState("");
  const [dateStart, setDateStart] = useState("");
  const [consultations, setConsultations] = useState("")


  useEffect(() => {
    const defaultLang = process.env.REACT_APP_LANG;
    const cookieLang =
      localStorage.getItem("lang") ||
      document.cookie
        .split("; ")
        .find((row) => row.startsWith("lang="))
        ?.split("=")[1] ||
      defaultLang;
    if (cookieLang) {
      import(`../../lang/profile/${cookieLang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
  }, []);

  useEffect(() => {
if (!profileData?.user) return;

  const user = profileData.user;

  setDateStart(user.date_start || "");
  setPseudo(user.nickname || "");
  setConsultations(profileData.consultations)




}, [profileData]);
  if (!languageData) {
    return <div></div>;
  }

  return (
    <div className="col-xxl-12 col-xl-12">
      <div className="card custom-card overflow-hidden">
        <div className="card-body d-sm-flex align-items-top p-4 main-profile-cover align-items-center justify-content-between">
          <div className="fs-12 op-7 mb-0 d-flex">
            <p className="mb-0">
              <p className="fw-bold fs-20 text-shadow mb-0 "> {pseudo}</p>
            </p>
          </div>

          <div className="main-profile-info text-start">
            <div className="">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex mb-0 flex-wrap">
                  <div className="me-4 mb-1">
                    <p className="fw-bold fs-20 text-shadow mb-0 ">{consultations}</p>
                    <p className="mb-0 fs-12 text-muted">
                      {languageData.header.consultations}
                    </p>
                  </div>
                  <div className="me-4 mb-1">
                    <p className="fw-bold fs-20 text-shadow mb-0">
                       {dateStart}
                    </p>
                    <p className="mb-0 fs-12 text-muted ">
                      {languageData.header.since}
                    </p>
                  </div>

                  <div className="me-7">
                    <button className="btn btn-primary d-flex align-items-center desactive-btn" data-interaction="expert_button">
                      {/*    <FaDownload className="me-2" /> */}
                      {languageData.header.exportData}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profilehead;
